var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-2 w-full",attrs:{"id":"container"}},[_c('canvas',{attrs:{"id":"webgl-canvas"}}),(_vm.showChromaControls)?_c('div',{attrs:{"id":"chroma-controls"}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }